export default __webpack_public_path__ + "static/media/au_shop.eebb94f7.svg";